import React, { Component } from 'react';
import { Container, Draggable } from 'react-smooth-dnd';

class CardBoxWithSorting extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cardBoxDataJSON:[...this.props.cardBoxData],
            searchValue:'',
        }
    }
   
    
      getPayload = (gridList,index) => {
        return {
          gridList: gridList,
          index:index,
          actionType:'sortCard',
        };
      }
    shouldComponentUpdate = (nextProps, nextState) => {				
		return ((this.props.cardBoxData !== nextProps.cardBoxData) || (this.state.cardBoxDataJSON !== nextProps.cardBoxDataJSON) );
	}
      componentDidUpdate = (prevProps) =>{
        if(prevProps.cardBoxData!==this.props.cardBoxData){
          this.setState({
            cardBoxDataJSON:[...this.props.cardBoxData],
            // searchValue:'',
        },()=>{this.searchCardBox(this.state.searchValue)});
        }
    }
      searchCardBox = (value)=>{
        let updatedData = []; 
        if(value.trim()!==''){
            const {cardBoxData} = this.props;
            cardBoxData.map((item)=>{
                const display_name = item.display_name.toLowerCase();
                if(display_name.indexOf(value.toLowerCase()) !== -1){
                    updatedData.push(item);
                }
            });
        }else{
            updatedData = [...this.props.cardBoxData];
        }
        this.setState({cardBoxDataJSON:updatedData,searchValue:value});
      }
    render () {
        const {boxId,cardBoxData,cardBoxCheckAndUncheckHandler,sortingFieldsHandler,left,right,isSplitViewOpen } = this.props;
        const {cardBoxDataJSON,searchValue} = this.state;
        return (
            
            <div className="card hidden_Box" id={boxId} style={{position: 'absolute',minWidth: '200px', zIndex: 6,left: 'inherit', right:(right)?right:'auto',display:'none',backgroundColor:'#fff',top:'50px'}}>
            <div className="card-header p-2">
                <div className="input-group ">
                    <input type="text" placeholder="Search" value={searchValue} onChange={e=>this.searchCardBox(e.target.value)} className="form-control" style={{background:'#e2e5f6', height:'40px'}} />
                </div>
            </div>	
            <div className="card-body p-2" style={{maxHeight:'200px',overflow:'auto'}}>
                <div className="detailList">
                    {(cardBoxDataJSON.length===0)?
                       <label className="pl-0">No data found..</label>
                    : 
                    <ul className="list-group list-group-bordered list">
                        <Container dragclassName="1dragclassNamednd"
                            onDrop={sortingFieldsHandler}
                            getChildPayload={this.getPayload.bind(this,cardBoxData)}
                            orientation={'vertical'}
                            lockAxis={'y'}
                          >
                        {
                            cardBoxDataJSON.map((item,index)=>{
                                const cardId = isSplitViewOpen ? item.id+"_"+index : item.id;
                                const display_name = item.display_name
                                const isShow = item.isShow;
                                const DraggableElement = (isShow===true)?{ element:Draggable}:{element:'div'}
                                return(
                                    <DraggableElement.element key={index}>
                                    <li className="list-group-item" key={cardId}  style={{padding:'0.35rem'}}>
                                        <div className="custom-control custom-checkbox">
                                            <input type="checkbox" className="custom-control-input" id={cardId} name={cardId} required="" onChange={cardBoxCheckAndUncheckHandler.bind(this,{
                                                index:index,
                                                cardId:item.id
                                            })} checked={isShow}
                                            />
                                            <label className="custom-control-label" htmlFor={cardId}>
                                                {display_name}
                                            </label>
                                        </div>
                                        {(isShow===true)?
                                            <span className="icon-right" style={{cursor: 'move'}}><i className="fas fa-arrows-alt third_light_color"></i></span>
                                            :''
                                        }
                                        
                                    </li>
                                    </DraggableElement.element>
                                )
                            })
                        }
                        </Container>
                       
                    </ul>
                }
                </div>
            </div>
            <div className="card-footer px-2"> 
                <div className="d-flex align-items-center justify-content-between">
                    
                    <button type="button" onClick={this.cancelCardBox} className="btn btn-cancel">Cancel</button>
                    <button type="button" onClick={this.updateCardBox} className=" btn primary_bg">Save 
                    </button>
                </div>
                     
            </div>
        </div>
            
        )
    }
    cancelCardBox = ()=>{
        const {boxId, cardBoxCancel, cardBoxToogle } = this.props;
        this.setState({cardBoxDataJSON:[...this.props.cardBoxData],searchValue:''});
        if (cardBoxCancel) {
          cardBoxCancel();
        } else if (cardBoxToogle) {
          // List grids (e.g. Shipments Header Column) close via #boxId; must pass boxId
          cardBoxToogle(boxId);
        }
    }
    updateCardBox = ()=>{
        const {updateDisplayingHandler } = this.props;
        this.setState({cardBoxDataJSON:[...this.props.cardBoxData],searchValue:''});
        updateDisplayingHandler();
    }
}

export default CardBoxWithSorting;